import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Accordion from 'react-bootstrap/Accordion';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Dropdown from 'react-bootstrap/Dropdown';
import Avatar from '@mui/material/Avatar';
import Form from 'react-bootstrap/Form';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ReplyIcon from '@mui/icons-material/Reply';
import { FaChevronDown } from 'react-icons/fa';
import BoltIcon from '@mui/icons-material/Bolt';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { getClientProfile, getAIResponse } from '../../common/api';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import PersonIcon from '@mui/icons-material/Person';


const Copilot = ( { uid, user, viewing, comms, loans, notes, contacts, cid, setMsg } ) => {
    const [ loading, setLoading ] = useState( true );
    const [ messages, setMessages ] = useState( [] );
    const [ prompt, setPrompt ] = useState( '' );
    const [ sending, setSending ] = useState( false );
    const [ c, setC ] = useState( {} );
    const [ profile, setProfile ] = useState( {} );
    const [ profileResponse, setProfileResponse ] = useState( {} );
    const [ suggestions, setSuggestions ] = useState( [] );

    const msgRef = useRef();
    const profilePrompt = 'Generate a profile...';

    const displayName =  useCallback( ( c ) => {
        let val;
        const fields = [ 'firstname', 'phoneMobile', 'phone', 'email' ];
        if ( c ) {
            for ( let i = 0; i < fields.length; i++ ) {
                if ( c[fields[i]] && c[fields[i]].length ) {
                    val = c[fields[i]];
                    break;
                }
            }
        }
        return val;
    }, [] );

    const formatInteractions = useCallback( ( cid ) => {
        const list = [];
        const formatted = [];
        Object.keys( comms ).forEach( commId => {
            const comm = comms[commId];
            if ( comm.assoc ) {
                const cr = comm.assoc.find( f => f.cid === cid );
                if ( cr ) {
                    list.push( comm );
                }
            }
        } );
        list.sort( ( a, b ) => {
            let ad = Date.parse( a.commDate );
                let bd = Date.parse( b.commDate );
                if ( !ad ) {
                    ad = Date.parse( a.createdDate );
                }
                if ( !bd ) {
                    bd = Date.parse( b.createdDate );
                }
                return ad - bd;
        } );
        list.forEach( msg => {
            formatted.push( {
                channel: msg.commType,
                date: msg.commDate ? msg.commDate : msg.createdDate,
                direction: msg.direction ? msg.direction : 'outbound',
                msg: msg.body ? msg.body : msg.details
            } );
        } );

        return formatted;
    }, [ comms ] );

    const formatLoans = useCallback( ( cid ) => {
        const list = [];
        const formatted = [];
        Object.keys( loans ).forEach( lid => {
            const l = loans[lid];
            if ( l.borrowers ) {
                const b = l.borrowers.find( f => f.cid === cid );
                if ( b ) {
                    list.push( l );
                }
            }
        } );
        list.sort( ( a, b ) => {
            let ad = Date.parse( a.createdDate );
            let bd = Date.parse( b.createdDate );
            return ad - bd;
        } );
        list.forEach( l => {
            formatted.push( {
                loanNumber: l.fileNum ? l.fileNum : 'Unknown',
                purpose: l.purpose ? l.purpose : 'Purchase',
                loanType: l.loanType ? l.loanType : 'Unknown',
                fthb: l.fthb ? l.fthb : 'Unknown',
                status: l.status,
                purchasePrice: l.purchasePrice ? l.purchasePrice : 'Unknown',
                amount: l.amount ? l.amount : 'Unknown',
                downpaymentAmount: l.downpaymentAmount ? l.downpaymentAmount : 'Unknown',
                rate: l.rate ? l.rate : 'Unknown',
                amortizationType: l.amortizationType ? l.amortizationType : 'Unknown',
                fileStartedDate: l.fileStartedDate ? l.fileStartedDate : 'Unknown',
                applicationStartedDate: l.appStartedDate ? l.appStartedDate : 'Unknown',
                applicationCompletedDate: l.appCompletedDate ? l.appCompletedDate : 'Unknown',
                preQualifiedDate: l.pqDate ? l.pqDate : 'Unknown',
                preApprovedDate: l.paDate ? l.paDate : 'Unknown',
                preApprovalNotes: l.notesPAReview ? l.notesPAReview : 'None',
                contractDate: l.contractDate ? l.contractDate : 'Unknown',
                inspectionContingencyDate: l.inspectionContDate ? l.inspectionContDate : 'Unknown',
                appraisalContingencyDate: l.appraisalContDate ? l.appraisalContDate : 'Unknown',
                loanContingencyDate: l.loanContDate ? l.loanContDate : 'Unknown',
                fundedDate: l.fundedDate ? l.fundedDate : 'Unknown',
                firstPaymentDate: l.firstPaymentDate ? l.firstPaymentDate : 'Unknown',
                occupancy: l.occupancy ? l.occupancy : 'Unknown',
                propertyType: l.propertyType ? l.propertyType : 'Unknown',
                propertyCity: l.subjectCity ? l.subjectCity : 'Unknown',
                propertyState: l.subjectState ? l.subjectState : 'Unknown'
            } );
        } );

        return formatted;
    }, [ loans ] );

    const formatNotes = useCallback( ( cid ) => {
        const list = [];
        const formatted = [];
        Object.keys( notes ).forEach( nid => {
            const n = notes[nid];
            if ( n.assoc ) {
                const na = n.assoc.find( f => f.cid === cid );
                if ( na ) {
                    list.push( n );
                }
            }
        } );
        list.sort( ( a, b ) => {
            let ad = Date.parse( a.createdDate );
            let bd = Date.parse( b.createdDate );
            return ad - bd;
        } );
        list.forEach( n => {
            let loan;

            if ( n.lid ) {
                if ( loans[n.lid] ) {
                    loan = loans[n.lid].fileNum;
                }
            } else if ( n.assoc[0].lid ) {
                if ( loans[n.assoc[0].lid] ) {
                    loan = loans[n.assoc[0].lid].fileNum;
                }
            }

            formatted.push( {
                title: n.name,
                details: n.details,
                relatedToLoan: loan ? loan : 'Unknown',
                createdBy: n.createdBy,
                createdDate: n.createdDate
            } );
        } );

        return formatted;
    }, [ notes, loans ] );

    const formatPersonInfo = ( c ) => {
        return {
            firstName: c.firstname ? c.firstname : 'Unknown',
            birthday: c.birthday ? c.birthday : 'Unknown',
            maritalStatus: c.maritalStatus ? c.maritalStatus : 'Unknown',
            language: c.languagePreferred ? c.languagePreferred : 'US English',
            internalRank: c.rank ? c.rank : 'n/a',
        }
    }

    const formatContactInfo = ( c ) => {
        let addr = '';
        
        if ( c.homeCity ) {
            addr = c.homeCity;
        }
        if ( c.homeState ) {
            if ( addr.length ) {
                addr += ', ';
            }
            addr += c.homeState;
        }

        if ( c.priRole === 'partner' && !addr.length ) {
            if ( c.workCity ) {
                addr = c.workCity;
            }
            if ( c.workState ) {
                if ( addr.length ) {
                    addr += ', ';
                }
                addr += c.workState;
            }
        }

        return {
            phone: ( c.phone || c.phoneMobile || c.phoneHome || c.phoneWork ) ? true : false,
            email: c.email ? true : false,
            address: addr.length ? addr : false
        }
    }

    const formatFinancials = ( c ) => {
        return {
            creditScore: c.lastKnownCredit ? c.lastKnownCredit : 'Unknown',
            employer: c.employer ? c.employer : 'Unknown',
            jobTitle: c.occupation ? c.occupation : 'Unknown'
        }
    }

    const generatePartnerProfile = ( c ) => {
        return {};    
    }

    const generateAssociateProfile = ( c ) => {
        return {};    
    }

    const generateBorrowerProfile = useCallback( ( c ) => {
        return {
            personalInfo: formatPersonInfo( c ),
            contactInfo: formatContactInfo( c ),
            loans: formatLoans( c.cid ),
            // interactions: formatInteractions( c.cid ),
            financials: formatFinancials( c ),
            notes: formatNotes( c.cid )
        }
    }, [ formatInteractions, formatLoans, formatNotes ] );

    const generateProfile = useCallback( ( c ) => {
        let obj = {};

        console.log( 'Generating profile for: ', c );

        if ( !c ) {
            return obj;
        }

        switch ( c.priRole ) {
            case 'borrower':
                obj = generateBorrowerProfile( c );
                break;

            case 'partner':
                obj = generatePartnerProfile( c );
                break;

            case 'associate':
                obj = generateAssociateProfile( c );
                break;

            default:
                console.log( 'Unknown contact role!', c );
        }

        return obj;
    }, [ generateBorrowerProfile ] );

    const askLeo = async ( pType ) => {
        setSending( true );

        switch ( pType ) {
            case 'askForProfile':
                console.log( 'askForProfile: ', profile );
                await getAIProfile();
                break;

            case 'askForAnything':
                console.log( 'askForAnything', prompt );
                await getLeoResponse();
                break;

            default:
                console.log( 'Unknown prompt type: ', pType );
        }
        setPrompt( '' );
        setSending( false );
    }

    const formatProfile = useCallback( ( profile ) => {
        console.log( 'formatProfile: ', profile );
        return (
            <>
                <Row className='pb-2'>
                    <Col>
                        {profile.overview}
                    </Col>
                </Row>
                {
                    profile.insights ? (
                        <Accordion class='pt-2'>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>General Insights and Observations</Accordion.Header>
                                <Accordion.Body>
                                    <ul>
                                    {
                                        profile.insights.map( ( i, idx ) => (
                                            <li key={idx}>{i}</li>
                                        ) )
                                    }
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    ) : (
                        null
                    )
                }
                {
                    profile.commStrategy ? (
                        <Accordion class='pt-2'>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Communication Strategy</Accordion.Header>
                                <Accordion.Body>
                                    <ul>
                                    {
                                        profile.commStrategy.map( ( i, idx ) => (
                                            <li key={idx}>{i}</li>
                                        ) )
                                    }
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    ) : (
                        null
                    )
                }
                {
                    profile.discProfile ? (
                        <Accordion class='pt-2'>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Personality Profile (DISC)</Accordion.Header>
                                <Accordion.Body>
                                    <p>{profile.discProfile.summary}</p>
                                    <ul>
                                        <li><strong>D - Ranks #{profile.discProfile.D.rank}</strong> - {profile.discProfile.D.evidence}</li>
                                        <li><strong>I - Ranks #{profile.discProfile.I.rank}</strong> - {profile.discProfile.I.evidence}</li>
                                        <li><strong>S - Ranks #{profile.discProfile.S.rank}</strong> - {profile.discProfile.S.evidence}</li>
                                        <li><strong>C - Ranks #{profile.discProfile.C.rank}</strong> - {profile.discProfile.C.evidence}</li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    ) : (
                        null
                    )
                }
                {
                    profile.nextSteps ? (
                        <Accordion class='pt-2'>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Recommended Next Steps</Accordion.Header>
                                <Accordion.Body>
                                    <ul>
                                        <li><strong>Timing:</strong> {profile.nextSteps.timing}</li>
                                        <li><strong>Purpose:</strong> {profile.nextSteps.purpose}</li>
                                        <li><strong>Channel:</strong> {profile.nextSteps.channel}</li>
                                        <li><strong>Message:</strong> {profile.nextSteps.message}    
                                                {
                                                    profile.nextSteps.message ? (
                                                        <span xs='auto' className='ms-2 leo-suggestion'>
                                                            <Button size='sm' style={ { fontSize: '10px', textDecoration: 'none' } } variant='link' className='leo-suggestion-button p-0 px-1' onClick={ () => setMsg( prev => prev + profile.nextSteps.message ) }><AutoAwesomeIcon style={ { fontSize: '20px' } } className='pe-1' />Use This...</Button>
                                                        </span>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                        </li>
                                        <li><strong>Rationale:</strong> {profile.nextSteps.rationale}</li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    ) : (
                        null
                    )
                }
                {
                    profile.nextLoan ? (
                        <Accordion class='pt-2'>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Potential Next Loan...</Accordion.Header>
                                <Accordion.Body>
                                    <ul>
                                        <li><strong>Purchase:</strong> {profile.nextLoan.purchase}</li>
                                        <li><strong>Refi:</strong> {profile.nextLoan.refi}</li>
                                        <li>
                                            <strong>Factors for This:</strong>
                                            <ul>
                                            {
                                                profile.nextLoan.factors.map( ( f, idx ) => (
                                                    <li key={idx}>{f}</li>
                                                ) )
                                            }
                                            </ul>
                                        </li>
                                        <li>
                                            <strong>Reasons for This:</strong>
                                            <ul>
                                            {
                                                profile.nextLoan.reasons.map( ( f, idx ) => (
                                                    <li key={idx}>{f}</li>
                                                ) )
                                            }
                                            </ul>
                                        </li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    ) : (
                        null
                    )
                }
                
            </>
        )
    }, [ setMsg ] );

    const getAIProfile = useCallback( async () => {
        setSuggestions( prev => suggestions.filter( s => s.action !== 'askForProfile' ) );
        setMessages( prev => [ ...prev, { role: 'user', content: 'Generate a profile...' } ] );
        const sent = await getClientProfile( c.aid, uid, profile, c.cid );
        setProfileResponse( sent );
        setMessages( prev => [ ...prev, { role: 'system', content: formatProfile( sent ) } ] );
    }, [ uid, c, profile, suggestions, formatProfile ] );

    const getLeoResponse = async () => {
        setMessages( prev => [ ...prev, { role: 'user', content: prompt } ] );

        const msgs = [
            {
                role: 'system',
                content: 'The following JSON object labeled "interactions" contains a list of all interactions the user has had with this specific contact. Please use it to influence your response.'
            },
            {
                role: 'system',
                content: 'interactions: ' + JSON.stringify( profile.interactions )
            }
        ];

        const chat = [];
        let next = false;
        messages.forEach( m => {
            if ( profileResponse ) {
                if ( m.content === profilePrompt ) {
                    next = true;
                    return;
                }
                if ( next ) {
                    chat.push( ...msgs );
                    chat.push( { role: 'system', content: 'The following is a JSON object containing the profile of the contact. Please use it to influence your response.' } );
                    chat.push( { role: m.role, content: JSON.stringify( profileResponse ) } );
                    next = false;
                    return;
                }
                chat.push( m );
            } else {
                chat.push( m );
            }
        } );
        if ( !profileResponse ) {
            chat.unshift( ...msgs );
        }
        console.log( 'chat: ', chat );
        const resp = await getAIResponse( c.aid, uid, chat, prompt );
        
        if ( resp ) {
            setMessages( prev => [ ...prev, { role: 'system', content: resp.display } ] );
            console.log( 'Response from AI', resp );
        } else {
            console.log( 'No response from AI', resp );
        }
    }

    useEffect( () => {
        if ( cid && contacts[cid] && ( !c || c.cid !== cid ) ) {
            console.log( 'Setting contact: ', contacts[cid] );
            setC( contacts[cid] );
            setMessages( [] );
            setSuggestions( [
                { label: `Generate ${displayName( contacts[cid] )}'s profile`, action: 'askForProfile' },
            ] );
            setProfile( generateProfile( contacts[cid] ) );
            setLoading( false );
        }
    }, [ cid, contacts, c, generateProfile, displayName ] );

    useEffect( () => {
        console.log( 'messages: ', messages );
    }, [ messages ] );

    return (
        <Container className="chat-container">
            <Row className='tf-contact-cv-name-container align-items-center' style={ { minHeight: '56px', maxHeight: '56px', lineHeight: '56px', borderBottom: '1px solid rgba( 224, 224, 224, 1 )' } }>
                <Col className='fs-6'>
                    <BoltIcon />
                    <span className='ps-3 fw-bold'>AI Copilot</span>
                </Col>
            </Row>
            <Row className="leo-messages" ref={msgRef}>
                <Col>
                {
                    !messages.length ? (
                        <div className='d-flex justify-content-center align-items-center' style={ { height: '100%', width: '100%' } }>
                            <div className='text-center'>
                                <span className='fw-semibold fs-5'>Hi, I'm Leo, your AI co-pilot</span><br />
                                <span>Ask me anything about this conversation...</span>
                            </div>
                        </div>
                    ) : (
                        messages.map( ( m, i ) => {
                            return (
                                <Row key={i} className={ `${m.role === 'user' ? 'leo-question' : 'leo-answer'} pb-3` }>
                                    <Col xs='auto' className='p-0'>
                                        <Avatar sx={ { width: 30, height: 30, bgcolor: m.role === 'user' ? 'var( --tf-blue )' : 'var( --tf-orange )' } }>
                                            { m.role === 'user' ? <PersonIcon /> : <BoltIcon /> }
                                        </Avatar>
                                    </Col>
                                    <Col>
                                        { m.content }
                                    </Col>
                                </Row>
                            );
                        } )
                    )
                }
                {
                    sending ? (
                        <Row className='leo-sending pt-2'>
                            <Col>
                                <div className='d-flex justify-content-center align-items-center' style={ { height: '100%', width: '100%' } }>
                                    <div className='text-center'>
                                        <Spinner animation="border" variant="primary" />
                                        <div className='fw-semibold fs-5 pt-2'>Hang on a sec...</div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    ) : (
                        null
                    )
                }
                </Col>
            </Row>
            <Row className='leo-suggestions pb-2 px-2'>
                {
                    suggestions.map( ( s, i ) => {
                        return (
                            <Col key={`leo-suggest-${i}`} xs='auto' className='p-0 leo-suggestion'>
                                <Button size='sm' style={ { fontSize: '12px', textDecoration: 'none' } } variant='link' className='leo-suggestion-button' onClick={ () => askLeo( s.action ) }><AutoAwesomeIcon style={ { fontSize: '26px' } } className='pe-1' /> {s.label}</Button>
                            </Col>
                        );
                    } )
                }
            </Row>
            <Row className="leo-input-container">
                <Col className='leo-msg-box'>
                    <Row>
                        <Col>
                            <Form.Control
                                as="textarea"
                                rows={1}
                                className="leo-input"
                                value={prompt}
                                onChange={ ( e ) => setPrompt( e.target.value ) }
                                placeholder="Type a message..."
                                style={ { border: 0 } }
                            />
                        </Col>
                        <Col xs='auto' className='pe-2 text-secondary'>
                            <Button className="inbox-button" onClick={ () => askLeo( 'askForAnything' ) } disabled={sending}><ArrowUpwardIcon /></Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    viewing: state.user.viewing,
    comms: state.comms.byId,
    loans: state.loans.byId,
    notes: state.notes.byId,
    contacts: state.contacts.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( Copilot );